import * as React from 'react'

const SvgMicroscopeIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6843 1.02978L12.9092 2.80493L14.6843 4.58008L16.4595 2.80493L14.6843 1.02978Z"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4656 2.3612L10.6904 4.13635L13.353 6.79894L15.1282 5.02379L12.4656 2.3612Z"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9036 15.6484H8.11719V19.4141H16.9036V15.6484Z"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.14039 7.6864L5.36523 9.46155L8.02813 12.1244L9.80328 10.3493L7.14039 7.6864Z"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2466 3.69234L6.69629 7.24268L10.2466 10.793L13.797 7.24268L10.2466 3.69234Z"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2412 0.585938L16.9038 3.24855"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.92188 9.01782L8.47227 12.5682"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9037 14.724C16.9037 13.0592 16.2425 11.4629 15.0655 10.2862C14.0171 9.23748 12.9096 8.13037 12.9096 8.13037L11.1345 9.90525C11.1345 9.90525 11.818 10.5887 12.492 11.2631C12.8381 11.6092 13.0327 12.0787 13.0327 12.5682C13.0327 13.0577 12.8381 13.5272 12.492 13.8733L10.7168 15.6484H16.9037V14.724Z"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.11719 15.6484H2.46875"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5309 19.4141H7.48926"
      stroke="white"
      strokeWidth="1.17188"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgMicroscopeIcon
